import React, { useEffect } from 'react';
import { HeroSection } from './components/sections/HeroSection';
import { StatsSection } from './components/sections/StatsSection';
import { GallerySection } from './components/sections/GallerySection';
import { VolumesSection } from './components/sections/VolumesSection';
import { BonusesSection } from './components/sections/BonusesSection';
import { OfferSection } from './components/sections/OfferSection';
import { ComparisonSection } from './components/sections/ComparisonSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { FaqSection } from './components/sections/FaqSection';
import { FinalCtaSection } from './components/sections/FinalCtaSection';
import { SiteFooter } from './components/SiteFooter';
import { PurchasePopup } from './components/PurchasePopup';
import { initMetaPixel, PIXEL_ID } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen w-full bg-zinc-950 text-zinc-50 antialiased" data-id="element-0" data-mp="3ijxoypkvdyjd">
      <noscript data-id="element-1" data-mp="3ihuyk4ft23e4">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="3mlj8uuvtnd32" />
      </noscript>
      <HeroSection data-id="element-3" data-mp="3recedkz46pg7" />
      <main data-id="element-4" data-mp="5yi8qe3h5da">
        <StatsSection data-id="element-5" data-mp="6hqtghuuhen" />
        <GallerySection data-id="element-6" data-mp="4wx1t3d72hu" />
        <VolumesSection data-id="element-7" data-mp="56mnfkhz7n0" />
        <BonusesSection data-id="element-8" data-mp="7sxpp6lk59z" />
        <OfferSection data-id="element-9" data-mp="2zllcouynw8jk" />
        <ComparisonSection data-id="element-10" data-mp="2zmepackaxs9m" />
        <TestimonialsSection data-id="element-11" data-mp="2zn6actg9w7ln" />
        <FaqSection data-id="element-12" data-mp="33mf2jtvnzxf3" />
        <FinalCtaSection data-id="element-13" data-mp="33lx02fiesmyq" />
      </main>
      <SiteFooter data-id="element-14" data-mp="33myl9ct52pu6" />
      <PurchasePopup data-id="element-15" data-mp="33oi152avuyvf" />
    </div>;
}